module.exports = __webpack_public_path__ + "static/media/landing_bg_mobile.0afb57d8.png";